import { sleep, trackerLog } from '@enuygun/frontend-components'
import dayjs from 'dayjs'

import { savePreviousCategoryBeforeSubmit } from 'utils/searchForm'

import { logHomepageSearchFormSubmit, resolveHomepageSearchRef } from './searchFormSubmitTracking'
import type { SearchFormSubmitOptions } from './submitOptions'

interface IHotel {
  id: string
  name: string
  slug: string
}

interface IRegion {
  type: number
  name: string
  slug: string
  countryCode: string
  id: number
}

interface IGuests {
  adults: number
  children: string[]
}

interface ISearchItem {
  checkInDate: string
  checkOutDate: string
  region: IRegion
  hotel: IHotel
  rooms: IGuests[]
  coordinate?: {
    latitude: number
    longitude: number
  }
}

export const getRooms = (guests: IGuests[]): string => {
  const guestArr = guests.map((guest) => {
    const childAges = guest.children.map((guest) => guest)
    return [guest.adults, ...childAges]
  })
  return guestArr.join('|')
}

export const getRedirectUrl = (searchItem: ISearchItem, ref: string = 'homepage'): string => {
  const { checkInDate, checkOutDate, hotel, region, rooms, coordinate } = searchItem

  const params = {
    checkInDate,
    checkOutDate,
    ref,
  }

  const logData = {
    category: 'hotel',
    check_in_date: dayjs(checkInDate).format('YYYY-MM-DD'),
    check_out_date: dayjs(checkOutDate).format('YYYY-MM-DD'),
    rooms: getRooms(rooms),
  }

  if (region.slug === 'konumum' && coordinate) {
    trackerLog({
      ...logData,
      latutide: coordinate.latitude.toString(),
      longitude: coordinate.longitude.toString(),
      type: 'location_search',
      slug: region.slug,
    })

    return `/otel/arama/${region.slug}/?${new URLSearchParams({
      ...params,
      roomDetail: getRooms(rooms),
      lat: coordinate.latitude.toString(),
      lon: coordinate.longitude.toString(),
      p: 'search',
    })}`
  }

  if (hotel.id) {
    trackerLog({
      ...logData,
      country: region.countryCode,
      type: 'hotel_detail',
      slug: hotel.slug,
    })

    return `/otel/detay/${hotel.slug}/?${new URLSearchParams({
      ...params,
      rooms: getRooms(rooms),
      autoRequest: '1',
      country: region.countryCode,
      p: 'hotel_detail',
      is_single_search: '1',
    })}`
  }

  trackerLog({
    ...logData,
    country: region.countryCode,
    type: 'region_search',
    slug: region.slug,
  })

  return `/otel/arama/${region.slug}/?${new URLSearchParams({
    ...params,
    roomDetail: getRooms(rooms),
    country: region.countryCode,
    p: 'search',
  })}`
}

const resolveHotelFromLocation = (location) => {
  if (location['elastic_type'] === 'hotel') {
    return {
      id: location.id,
      name: location.name,
      slug: location.slug,
    }
  }

  return {
    id: null,
    name: null,
    slug: null,
  }
}

export const hotelHandleSubmit = async (form, options: SearchFormSubmitOptions = {}) => {
  const { index = null, delay = 0, variant, productCategory } = options
  const refValue = resolveHomepageSearchRef(variant)

  if (index !== null) savePreviousCategoryBeforeSubmit(String(index))
  logHomepageSearchFormSubmit({ variant, productCategory: productCategory || 'otel' })

  const redirectUrl = getRedirectUrl(
    {
      checkInDate: dayjs(form.date.startDate).format('DD.MM.YYYY'),
      checkOutDate: dayjs(form.date.endDate).format('DD.MM.YYYY'),
      rooms: form.guests,
      region: form.location,
      coordinate: form.location.coordinate,
      hotel: resolveHotelFromLocation(form.location),
    },
    refValue
  )

  await sleep(delay)

  globalThis.location.href = redirectUrl
}
